import { FC, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment';
import { get } from 'lodash';
import { Container } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';

export interface ContestationDateAudienceProps {
  intl: IntlShape;
  updateContestation?: Function | undefined;
  contestationHearingDate?: Date | null;
  judgementOnMerits: any;
  claimNumber?: string;
  lossDate?: string;
  jmc: any;
  isLawyer?: boolean;
  handleSuccessCallback: Function;
  disabled?: boolean;
}

const ContestationDateAudience: FC<ContestationDateAudienceProps> = props => {
  const [hearingDate, setHearingDate] = useState(props.contestationHearingDate);
  const [errorDate, setErrorDate] = useState(false);

  const handleChangeDateHearing = (date: Date | null) => {
    setErrorDate(false);
    const theDate = getDateIgnoreTimezone(date);
    const hearing = moment(theDate as Date);
    setHearingDate(hearing as any);
    if (addDaysToDate(props.lossDate || '', 0)) {
      if (
        new Date(addDaysToDate(props.lossDate || '', 0) || '') >
        new Date(theDate)
      ) {
        setErrorDate(true);
      }
    }
  };

  const cancelSelectedAudienceDate = () => {
    setHearingDate(null);
  };

  const validateAudienceDate = () => {
    if (props.updateContestation) {
      props.updateContestation(
        props.judgementOnMerits.jom.jmc.id,
        hearingDate,
        props.judgementOnMerits.jom.jmc.lawyerOpinion,
        props.judgementOnMerits.claimId,
        props.judgementOnMerits.procedureType,
        props.judgementOnMerits.judiciaryProcessId,
        props.judgementOnMerits.validator,
        PROCEDURE_STATUSES.PENDING,
        props.claimNumber,
        props.isLawyer,
        true,
        props.handleSuccessCallback,
      );
    }
  };
  return (
    <Container className="subContainer">
      <div style={{ marginBottom: 40, width: '25%' }}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <KeyboardDatePicker
            fullWidth
            autoOk
            minDate={addDaysToDate(props.lossDate || '', 1)}
            variant="inline"
            format="dd/MM/yyyy"
            id="date-picker-audience-date"
            data-testid="date-picker-audience-date"
            label={
              hearingDate
                ? ''
                : translate({ ...messages.hearingDateField }, props)
            }
            className="input"
            name={CIVIL_PROCEEDING_INFORMATIONS_FIELDS.HEARING_DATE}
            value={hearingDate}
            onChange={handleChangeDateHearing}
            disabled={
              get(props.jmc, 'status', '') === PROCEDURE_STATUSES.VALIDATED ||
              props.disabled
            }
            error={errorDate}
            helperText={
              errorDate && translate(messages.hearingDateError, props)
            }
          />
        </MuiPickersUtilsProvider>
      </div>

      {!(
        get(props.jmc, 'status', '') === PROCEDURE_STATUSES.VALIDATED ||
        props.disabled
      ) && (
        <div className="subContainer">
          <PrimaryButton
            className="validate-button"
            data-testid="validate"
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            title={translate(messages.validateButton, props)}
            onClick={validateAudienceDate}
            disabled={errorDate}
          />
          <SecondaryButton
            title={translate(messages.cancelButton, props)}
            data-testid="go-back"
            onClick={cancelSelectedAudienceDate}
          />
        </div>
      )}
    </Container>
  );
};

export default injectIntl(ContestationDateAudience);
